<template>
  <div :ref="'additionalAgreementId' + additional.id" class="application__form__block">
    <h4 class="add__fields__title space__between">
      {{ additional.lastFile?.file?.filename }}
      <button v-if="additional.actions?.some(action => action.constName === 'APPLICANT_ADDITIONAL_AGREEMENT_SIGN_ACTION')" type="button"
              class="button button--default button--bordered"
              @click="$emitter.emit('openAdditionalAgreementSignModal', {additionalAgreementId: additional.id})">
        {{ $lang.app.SIGN }}</button>
      <button v-if="additional.actions?.some(action => action.constName === 'APPLICANT_ADDITIONAL_AGREEMENT_DELETE_ACTION')"
              @click="deleteAdditionalAgreement" type="button" :title="$lang.app.DELETE" class="text-gray-300 ml-2">
        <svg class="fill-current" viewBox="0 0 24 24" width="24" height="24">
          <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
        </svg>
      </button>
    </h4>
    <Loader v-if="!file" class="my-5"/>
    <div v-else class="docs__pdf w-full">
      <embed class="w-full h-full" :src="`data:application/pdf;toolbar=0&;base64,${file.base64}`">
    </div>

    <div class="stack__list mt2" v-if="additional.lastFile?.basisFile">
      <div class="stack__label">{{ $lang.app.BASIS_FOR_ADDITIONAL_AGREEMENTS }}</div>
      <div class="flex justify-between items-center mb-3">
        <button type="button" class="file__item w-full" @click="loadBasisFile(this.additional.id)">
          <svg class="flex-shrink-0" viewBox="0 0 24 24" width="24" height="24"><use xlink:href="/img/sprite.713de447.svg#icon__file__pdf"></use></svg>
          <span class="max-w-lg file__item__name break-words">{{ additional.lastFile?.basisFile?.filename }}</span>
        </button>
      </div>
    </div>

    <div v-if="additional.comments.length" class="mt-4 bg-red-200 px-2 py-2 rounded">
      <div v-for="comment in additional.comments" :key="comment.id">
        {{ comment.comment }}
      </div>
    </div>

    <div v-if="additional.signers?.length" class="panel mt2 mb0">
      <div v-for="(signer, index) in additional.signers" :key="index" class="row">
        <div class="col-lg-9">
          <div class="stack__list">
            <div class="stack__label">{{ $lang.app.AGREEDS }}</div>
            <div class="stack__value">{{ signer.fullName }} <br> <span class="text-gray-400 font-light">{{ signer.executorName }}</span></div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="stack__list">
            <div class="stack__label">{{ $lang.app.SIGNED_DATE }}</div>
            <div v-if="signer.signDate" class="stack__value">
              {{ $moment(signer.signDate).format('DD.MM.YYYY') }} <br>
              {{ $moment(signer.signDate).format('HH:mm') }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <button v-if="additional.actions?.some(action => action.constName === 'APPLICANT_ADDITIONAL_AGREEMENT_EDIT_ACTION')"
            type="button" class="add__field__edit mt-4"
            @click="$emitter.emit('openAdditionalAgreementEditModal', {
                      agreementId: this.agreement.id,
                      additionalAgreementId: additional.id
                    })">
      <svg viewBox="0 0 24 24" width="24" height="24">
        <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
      </svg>
      {{ $lang.app.EDIT }}
    </button>


  </div>
</template>
<script>
import applicationApi, {getAdditionalAgreementFile, deleteAdditionalAgreement} from "@/api/applicant/application";
import fileMixin from "@/mixins/fileMixin";

export default {
  props: {
    agreement: Object,
    additional: Object,
  },
  data() {
    return {
      file: null,
    }
  },
  mounted() {
    if(this.$route.query.additionalAgreementId && this.$route.query.additionalAgreementId == this.additional.id) {
      const el = this.$refs['additionalAgreementId' + this.$route.query.additionalAgreementId];

      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    }
  },
  created() {
    this.initFile()
  },
  mixins: [fileMixin],
  methods: {
    initFile() {
      getAdditionalAgreementFile(this.agreement.id, this.additional.id)
          .then((response) => {
            this.file = response.data
          })
          .catch((error) => {
            this.$snotify.error(error);
          });
    },
    loadBasisFile(additionalId) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getAdditionalAgreementBasisFile(this.agreement.id, additionalId)
          .then(({data})=> {
            const blob = this.base64toBlob(data.base64, data.mimeType);
            this.$emitter.emit('open-blob-file-modal', {
              file: data,
              blobFile: URL.createObjectURL(blob)
            })
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    deleteAdditionalAgreement() {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          deleteAdditionalAgreement(this.agreement.id, this.additional.id).then(({data}) => {
            this.$snotify.success(data.message)
            this.$emitter.emit('refreshAdditionalAgreements')
          }).catch(error => {
            this.$snotify.error(error)
          })
        }
      })
    }
  }
}
</script>